<template>
  <div
    :class="{ 'has-logo': showLogo }"
    :style="isPlus ? 'padding-top: 30px;' : ''"
  >
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routersSidebar"
          :key="route.name"
          :item="route"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";
import { getLogionUserInfo } from "@/utils/auth";

export default {
  components: {
    SidebarItem,
    Logo,
  },
  data() {
    return {
      isAgentLogin: null,
    };
  },
  mounted() {
    this.isAgentLogin = getLogionUserInfo().isAgentLogin;
  },
  computed: {
    ...mapGetters(["sidebar", "routers"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      console.log("__1232312----", meta, path);
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
    isPlus() {
      return window.plus;
    },
    routersSidebar() {
      console.log("getLogionUserInfo路由-1", this.routers, this.isAgentLogin);
      if (this.isAgentLogin == 2) {
        return this.routers.filter((item) => item.name != "收款方式");
      }
      console.log("getLogionUserInfo路由-2", this.routers);
      return this.routers;
    },
  },
};
</script>
